// extracted by mini-css-extract-plugin
export default {"overlay":"EA-z","bodyOpen":"FA-z","content":"GA-z","header":"HA-z","close":"IA-z","closeNoHeading":"JA-z"};